// extracted by mini-css-extract-plugin
export default {"container":"TermsFragment_container__vl0I8"};